module.exports = __webpack_public_path__ + "static/img/top_message_ph.430a577.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/top_message_ph.png
// module id = R4h7
// module chunks = 0